import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ProductList.css';
import './Header.css';
import './CategoryProduct.css';

import { Link } from 'react-router-dom';
import { IoIosBasket } from 'react-icons/io';
import useAddToCart from './AddToCartButton';
import { useCart } from './CartContext'; // Import CartContext for real-time updates
import BASE_URL from '../config';

const ITEMS_PER_PAGE = 8;

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [messages, setMessages] = useState({});
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
  const { fetchCart } = useCart(); // Fetch cart for real-time updates
  const { handleAddToCart, loading: addToCartLoading, error: addToCartError, success: addToCartSuccess } = useAddToCart();

  // Fetch product data on component mount
  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/products/?format=json`)
      .then(response => {
        setProducts(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError(err);
        setLoading(false);
      });
  }, []);

  // Handle Add to Cart button click
  const onAddToCartClick = async (product) => {
    try {
      await handleAddToCart(product.slug, 1, fetchCart); // Pass fetchCart to refresh the cart
      setMessages(prevState => ({ ...prevState, [product.slug]: 'Item added to cart successfully!' }));
    } catch (err) {
      setMessages(prevState => ({ ...prevState, [product.slug]: 'Failed to add item to cart.' }));
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner-border text-primary" role="status">
        </div>
      </div>
    );
  }

  if (error) return null;

  return (
    <div className="container product-list-container">
      <div className='anyhead text-center'>
        <h2 className='text-center'>All Items</h2>
      </div>
      <div className="row">
        {products.slice(0, visibleCount).map(product => (
          <div key={product.id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
            <div className="card h-100 position-relative">
              {/* Add to Cart Button */}
              <button
              
                className="labelstyle"
              >
                {product.label}
              </button>
              {product.label !== 'Service' && (
              <button
                onClick={() => onAddToCartClick(product)}
                disabled={addToCartLoading || (product.stock !== null && product.stock !== undefined && product.stock <= 0)}
                className="add-to-cart-button"
              >
                {addToCartLoading ? 'Adding...' : <IoIosBasket />}
              </button>
              )}

              {/* Out of stock badge */}
              {product.stock !== null && product.stock !== undefined && product.stock <= 0 && (
                <span className="stock-badge-card out-of-stock">Out of stock</span>
              )}

              {/* Show success or error messages */}
              {messages[product.slug] && (
                <p className="text-center cart-message">{messages[product.slug]}</p>
              )}

              {/* Product Image */}
              <Link to={`/product/${product.slug}`}>
                <img
                  src={product.mainimage}
                  alt={product.title}
                  className="card-img-top product-image"
                  loading="lazy"
                />
              </Link>

              {/* Product Details */}
              <div className="card-body text-center">
                <h5 className="card-title">{product.title}</h5>
                <p className="card-text">
                  {product.label === 'Service'
                    ? <strong><Link to={`/product/${product.slug}`} className="get-quote-link">Get a Quote</Link></strong>
                    : <><strong>Price:</strong> CHF {product.price}</>
                  }
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className='anyhead text-center mt-3'>
        {visibleCount < products.length ? (
          <button className='cta load-more-btn' onClick={() => setVisibleCount(prev => prev + ITEMS_PER_PAGE)}>
            Load More
          </button>
        ) : (
          <a href='/products'><button className='cta'>View All in Shop</button></a>
        )}
      </div>
    </div>
  );
};

export default ProductList;
